import React, { useEffect, useState } from 'react'
import { IRequestedItem } from '.'
import { Avatar } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'

interface IRequestItemSubItemsProps {
    requestedItem: IRequestedItem,
    requestedItems: IRequestedItem[],
    isItemRequestPage?: boolean,
}

export default function RequestItemSubItems(props: IRequestItemSubItemsProps) {

    const { requestedItem, requestedItems, isItemRequestPage } = props

    const [subItems, setSubItems] = useState<IRequestedItem[]>([])

    const getItemsFromContainer = (containerId: number) => {
        return requestedItems.filter(item => item.item.parent_item === containerId)
    }

    useEffect(() => {
        if (requestedItem.item.is_container){
            setSubItems(getItemsFromContainer(requestedItem.item_id))
        }
    }, [])

    if (!requestedItem.item.is_container){
        return <></>
    }

    return(
        <div className="requested-item-sub-items-container">
            <div className="content-of-requested-item-sub-items-container">
                <h3 className="allocations-title">Container Items ({subItems.length}):</h3>
                {subItems.map((subItem, index: number) => {

                    return(
                        <div className="single-requested-item-allocation" key={index}>
                            <div className="content-of-single-requested-item-allocation">
                
                                <div className="fields-of-single-requested-item-allocation">
                                    <div className="content-of-fields-of-single-requested-item-allocation">
                
                                        <div className="field-of-single-requested-item-allocation thumbnail">
                                            <div className="content-of-field-of-single-requested-item-allocation">
                                                <Avatar src={subItem.item.thumbnail}>
                                                    <GenerateIcon icon="image" />
                                                </Avatar>
                                            </div>
                                        </div>
                
                                        <div className="field-of-single-requested-item-allocation text" style={{ maxWidth: 200, minWidth: 200 }}>
                                            <div className="content-of-field-of-single-requested-item-allocation">
                                                <h4>Item</h4>
                                                <a href={isItemRequestPage ? `/panel/items/view/${subItem.item.unique_id}` : `/items/${subItem.item.unique_id}`} target="_blank"><h3>{subItem.item.title}</h3></a>
                                            </div>
                                        </div>

                                        <div className="field-of-single-requested-item-allocation text" style={{ maxWidth: 200, minWidth: 200 }}>
                                            <div className="content-of-field-of-single-requested-item-allocation">
                                                <h4>Serial Number</h4>
                                                <h3>{subItem.item.serial_number ? subItem.item.serial_number : "-"}</h3>
                                            </div>
                                        </div>

                                        <div className="field-of-single-requested-item-allocation text" style={{ maxWidth: 200, minWidth: 200 }}>
                                            <div className="content-of-field-of-single-requested-item-allocation">
                                                <h4>Unique ID</h4>
                                                <h3>{subItem.item.unique_id}</h3>
                                            </div>
                                        </div>
                
                                        <div className="field-of-single-requested-item-allocation text" style={{ maxWidth: 120, minWidth: 120 }}>
                                            <div className="content-of-field-of-single-requested-item-allocation">
                                                <h4>Requested Quantity</h4>
                                                <h3>{subItem.item.quantity}</h3>
                                            </div>
                                        </div>
                
                                    </div>
                                </div>
                
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}